// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const McpConsentDecisionOut = zod.object({
  "redirect_url": zod.string()
});

export type McpConsentDecisionOut = zod.input<typeof McpConsentDecisionOut>;
export type McpConsentDecisionOutOutput = zod.output<typeof McpConsentDecisionOut>;
